import { CalcImportController } from "../../../controllers";
import { DataImportComponentBase } from "./DataImportComponentBase";

/**
 * User interface for calculation mass loading.
 * @example
 * ```html
 * <salaxy-calc-import></salaxy-calc-import>
 * ```
 */
export class CalcImport extends DataImportComponentBase {

    /** Uses the CalcImportController */
    public controller = CalcImportController;

}